// 欣欣小助手 panel, 数据看板, explorer, home, 资料索引
const en = {
  // copilot-panel
  "刚刚": "just now",
  "{minutes}分钟前": "{minutes} min ago",
  "{hours}小时前": "{hours} h ago",
  "{days}天前": "{days} d ago",
  "{s} 秒": "{s} s",
  "待确认": "Awaiting confirmation",
  "已执行": "Done",
  "已取消": "Cancelled",
  "执行失败": "Failed",
  "无法读取该图片。": "Couldn't read this image.",
  "粘贴图片-{pad(now.getHours())}{pad(now.getMinutes())}{pad(now.getSeconds())}.{ext}":
    "pasted-image-{pad(now.getHours())}{pad(now.getMinutes())}{pad(now.getSeconds())}.{ext}",
  "点击查看大图": "Click to enlarge",
  "{p.source} · 已审核": "{p.source} · vetted",
  "· 网络图片，未经审核": " · web image, not vetted",
  "加载对话失败。": "Failed to load the conversation.",
  "加载记忆失败。": "Failed to load memories.",
  "保存记忆失败。": "Failed to save the memory.",
  "保存设置失败。": "Failed to save settings.",
  "确定删除这条记忆吗？欣欣小助手之后将不再参考它。": "Delete this memory? Xinxin Assistant will stop using it.",
  "删除记忆失败。": "Failed to delete the memory.",
  "加载历史对话失败。": "Failed to load past conversations.",
  "确定删除这条历史对话吗？此操作无法撤销。": "Delete this conversation? This cannot be undone.",
  "删除对话失败。": "Failed to delete the conversation.",
  "页面上未保存的修改自动保存失败（原因见页面提示），本次提问未发送。":
    "Auto-saving the page's unsaved changes failed (see the page for details), so your question wasn't sent.",
  "发送失败，请重试。": "Send failed, please try again.",
  "上传失败。": "Upload failed.",
  "每条消息最多添加 {MAX_ATTACHMENTS_PER_MESSAGE} 个附件。": "You can attach at most {MAX_ATTACHMENTS_PER_MESSAGE} files per message.",
  "每条消息最多添加 {MAX_ATTACHMENTS_PER_MESSAGE} 个附件，多出的文件已忽略。":
    "You can attach at most {MAX_ATTACHMENTS_PER_MESSAGE} files per message; the extra files were ignored.",
  "请至少选择一条消息。": "Please select at least one message.",
  "导出失败，请重试。": "Export failed, please try again.",
  "操作失败，请重试。": "Operation failed, please try again.",
  "排队中{0}…": "Queued{0}…",
  "（第 {task.queuePosition} 位）": " (#{task.queuePosition})",
  "正在取消…": "Cancelling…",
  "正在处理，已用时 {0}": "Working, {0} elapsed",
  "处理被中断": "Interrupted",
  "处理失败": "Failed",
  "您可以继续提问，完成后回复会显示在这里。": "You can keep asking; the reply will appear here when it's ready.",
  "重试": "Retry",
  "忽略": "Dismiss",
  "新建课程设计失败。": "Failed to create the course design.",
  "下载失败，请重试。": "Download failed, please try again.",
  "生成中...": "Generating...",
  "打印 / 另存为 PDF": "Print / Save as PDF",
  "下载": "Download",
  "已记住": "Remembered",
  "已忘记": "Forgotten",
  "查看记忆": "View memories",
  "新建中...": "Creating...",
  "新建为课程设计": "Create as course design",
  "执行中...": "Running...",
  "确认执行": "Confirm",
  "打开《{link.title}》": "Open \"{link.title}\"",
  "新建对话失败。": "Failed to start a new conversation.",
  "参考资料：": "References: ",
  "网络来源（未经审核，请自行核实）：": "Web sources (not vetted, please verify): ",
  "关闭欣欣小助手": "Close Xinxin Assistant",
  "打开欣欣小助手": "Open Xinxin Assistant",
  "拖动调整大小": "Drag to resize",
  "松开即可添加为附件": "Drop to attach",
  "欣欣小助手": " Xinxin Assistant",
  "将对话导出为 Word / Markdown / PDF": "Export the conversation as Word / Markdown / PDF",
  "导出": "Export",
  "欣欣小助手跨对话记住的关于您的信息": "What Xinxin Assistant remembers about you across conversations",
  "返回": "Back ",
  "记忆": "Memory",
  "历史": "History",
  "新对话": "New chat",
  "欣欣小助手会在今后的所有对话中参考以下信息。您可以在对话中说「记住……」「忘掉……」，也可以在这里直接添加、修改或删除。":
    "Xinxin Assistant uses the following in all future conversations. You can say \"remember…\" or \"forget…\" in a chat, or add, edit and delete items here.",
  "对话结束一段时间后，由 AI 判断其中是否有值得长期记住的信息（标注「自动」）":
    "A while after a conversation ends, AI decides whether anything in it is worth remembering long-term (marked \"Auto\")",
  "允许欣欣小助手自动记住对话中的重要信息": " Let Xinxin Assistant automatically remember important things from conversations",
  "暂无记忆。": "No memories yet.",
  "欣欣小助手根据对话自动记住的信息": "Remembered automatically from a conversation",
  "自动": "Auto",
  "修改": "Edit",
  "如：任教五年级语文，班上约 30 名学生，多为留守儿童": "e.g. I teach Grade 5 Chinese, about 30 students, mostly left-behind children",
  "保存中...": "Saving...",
  "+ 添加记忆": "+ Add memory",
  "暂无历史对话。": "No past conversations.",
  "删除这条历史对话": "Delete this conversation",
  "正在查看：": "Viewing: ",
  "历史对话": "Past conversation",
  "返回当前对话": "Back to current chat",
  "{displayName}，有什么可以帮您的？": "Hi {displayName}, how can I help?",
  "有什么可以帮您的？": "How can I help?",
  "选择这条消息导出": "Select this message for export",
  "复制": "Copy",
  "这条消息针对课程设计中的这一部分": "This message is about this part of the course design",
  "针对：": "About: ",
  "思考中...": "Thinking...",
  "整段对话": "Whole conversation",
  "选择部分消息": "Selected messages",
  "已选": "Selected",
  "条": "",
  "清空": "Clear",
  "导出为：": "Export as:",
  "打开打印对话框，选择「另存为 PDF」": "Opens the print dialog; choose \"Save as PDF\"",
  "提问会附带这一部分的当前内容（含未保存的修改）": "Your question will include this part's current content (including unsaved changes)",
  "不再针对这一部分": "Stop focusing on this part",
  "上传 {0}%": "Uploading {0}%",
  "识别中...": "Recognizing...",
  "解析中...": "Parsing...",
  "移除": "Remove",
  "添加附件（Word、PPT、PDF、Excel、文本或图片；也可直接粘贴截图或拖入文件）":
    "Attach files (Word, PPT, PDF, Excel, text or images; you can also paste a screenshot or drag files in)",
  "说明需要如何处理附件（可不填）...": "Describe what to do with the attachments (optional)...",
  "就「{0}」提问（Shift+Enter 换行）...": "Ask about \"{0}\" (Shift+Enter for a new line)...",
  "输入问题，或粘贴截图（Shift+Enter 换行）...": "Type a question or paste a screenshot (Shift+Enter for a new line)...",
  "附件处理中，请稍候": "Attachments are still processing, please wait",
  "发送（Enter）": "Send (Enter)",
  "发送": "Send",

  // dashboard
  "数据看板仅对管理员和专家开放。": "The Dashboard is available to admins and experts only.",
  "导出 Excel（{visibleRows.length} 行）": "Export Excel ({visibleRows.length} rows)",
  "导出当前筛选结果，按当前排序。": "Exports the current filtered results in the current sort order.",
  "提交状态": "Submission",
  "全部": "All",
  "未提交（草稿）": "Not submitted (draft)",
  "总体设计完成度（%）": "Overall design completion (%)",
  "分课时设计完成度（%）": "Lesson design completion (%)",
  "实施完成度（%）": "Implementation completion (%)",
  "AI 打分": "AI score",
  "已打分": "Scored",
  "AI 用量（万 tokens）": "AI usage (×10k tokens)",
  "清除筛选": "Clear filters",
  "共 {rows.length} 个课程": "{rows.length} courses",
  "筛选出 {visibleRows.length} / {rows.length} 个课程": "Showing {visibleRows.length} / {rows.length} courses",
  "，已提交 {0} 个": ", {0} submitted ",
  "，平均总体设计完成度 {avgGeneral}%，平均分课时设计完成度 {avgLessonDesign}%，平均实施完成度 {avgExecution}%":
    ", avg. overall design {avgGeneral}%, avg. lesson design {avgLessonDesign}%, avg. implementation {avgExecution}%",
  "，已打分 {scoredRows.length} 个": ", {scoredRows.length} scored ",
  "，AI 平均分 {avgScore}": ", AI average {avgScore}",
  "各部分按模板字段的填写比例计算。总体设计完成度 = 基本信息 20% + 课程设计（WHY/WHAT/HOW）80%；分课时设计完成度覆盖全部课时的分课时设计，越靠前的课时权重越高（线性递减）；实施完成度覆盖全部课时，各课时权重相同，每课时 = 实施记录 50% + 支撑材料 50%（已上传任一文件即计满）":
    "Each part is the share of template fields filled in. Overall design = basic info 20% + course design (WHY/WHAT/HOW) 80%. Lesson design covers every lesson's design, with earlier lessons weighted more (linearly decreasing). Implementation covers every lesson equally; each lesson = implementation record 50% + supporting materials 50% (any uploaded file counts as full).",
  "总体设计 = 基本信息 20% + 课程设计（WHY/WHAT/HOW）80%；分课时设计 = 全部课时（靠前课时权重更高）；实施 = 全部课时的实施记录（各课时等权）":
    " Overall design = basic info 20% + course design (WHY/WHAT/HOW) 80%; lesson design = all lessons (earlier weighted more); implementation = all lessons' records (equal weight)",
  "是否提交": "Submitted",
  "专家点评": "Expert reviews",
  "优秀案例": "Exemplary",
  "基本信息 {c.basic}% · 课程设计 {c.design}%": "Basic info {c.basic}% · Course design {c.design}%",
  "{c.lessonCount} 课时": "{c.lessonCount} lessons",
  "查看各维度打分理由": "See per-dimension scoring rationale",
  "内容已修改": "Content changed",
  "{er.count} 条点评": "{er.count} reviews",
  "· 均分 {er.averageScore}": "· avg. {er.averageScore}",
  "暂无": "None",
  "{0} tokens（AI 打分/点评、关于本课程的欣欣小助手对话）": "{0} tokens (AI scoring/review and Xinxin Assistant chats about this course)",
  "标准版本 #{s.standardId} · 打分时间": "Rubric version #{s.standardId} · scored",

  // explorer-pane
  "目录": " Contents",

  // home
  "教师撰写、实施并分享乡土课程；专家与AI智能体协同点评；管理员维护学习资源库与课程案例库。":
    "Teachers design, teach and share local-culture courses; experts and AI agents review them together; admins maintain the Resource Library and Course Gallery.",
  "欢迎回来，": "Welcome back, ",
  "请": "Please ",
  "或": " or ",
  "后开始使用，或直接浏览下方公开内容。": " to get started, or browse the public content below.",
  "撰写课程设计方案、按课时记录实施过程、上传照片与材料、申请专家/AI点评。":
    "Write course designs, record each lesson as you teach it, upload photos and materials, and request expert/AI reviews.",
  "前往我的乡土课程": "Go to My Courses",
  "按 WHY/WHAT/HOW 分模块查看教师提交的课程设计与实施记录并给出点评。":
    "Review teachers' course designs and implementation records section by section (WHY/WHAT/HOW).",
  "前往待点评案例": "Go to Awaiting Review",
  "浏览讲座材料、培训视频等，可按乡土主题与年级筛选。": "Browse lecture materials, training videos and more, filtered by theme and grade.",
  "浏览学习资源库": "Browse the Resource Library",
  "无需登录即可浏览的优秀乡土课程案例展示墙。": "A showcase of exemplary courses, open to everyone without logging in.",
  "查看优秀案例": "See exemplary courses",

  // knowledge-index
  "文件": "File",
  "基本信息": "Basic info ",
  "第 {c.pageFrom} 页": "p. {c.pageFrom}",
  "第 {c.pageFrom}–{c.pageTo} 页": "pp. {c.pageFrom}–{c.pageTo}",
  "加载资料索引失败。": "Failed to load the materials index.",
  "将重新提取并索引此主题下的全部资料（每份资料约需数十秒），期间 AI 功能仍使用旧索引。确定继续吗？":
    "All materials in this topic will be re-extracted and re-indexed (tens of seconds each). AI features keep using the old index meanwhile. Continue?",
  "重建资料索引失败。": "Failed to rebuild the materials index.",
  "加载原文中…": "Loading source text…",
  "暂无原文。": "No source text.",
  "资料索引": "Materials index",
  "重建中…": "Rebuilding…",
  "重建资料索引": "Rebuild index",
  "知识库按三层组织：上方的": "The knowledge base has three layers: the ",
  "主题知识卡片": "topic knowledge card",
  "概括整个主题；下面是每份资料的": " at the top summarizes the topic; below are each material's ",
  "摘要与内容条目": "summary and content entries",
  "；点击条目可查看对应的": "; click an entry to see the ",
  "原文": "source text",
  "（注明页码）。AI 点评、AI 点评标准与欣欣小助手按这些摘要与条目找到相关资料，并对每段原文做语义匹配，再引用其原文。":
    " (with page numbers). AI review, the AI review rubric and Xinxin Assistant use these summaries and entries to find relevant materials, semantically match each passage, and quote the source.",
  "正在重建此主题的资料索引…": " Rebuilding this topic's materials index…",
  "此主题下暂无已索引的资料。": "No indexed materials in this topic yet.",
  "{s.charCount} 字": " {s.charCount} chars ",
  " · 语义索引 {s.embeddedCount}/{s.chunkCount} 段": " · semantic index {s.embeddedCount}/{s.chunkCount} chunks",
  "收起原文": "Hide source",
  "全文": "Full text",
  "展开条目（{s.contents.length}）": "Show entries ({s.contents.length})",
  "收起条目": "Hide entries",
  "尚未生成摘要": "No summary yet ",
  "，可点击「重建资料索引」生成。": "; click \"Rebuild index\" to generate one.",
};
export default en;
